import React from 'react'

function Recruitment() {
  return (
    <div>
      
    </div>
  )
}

export default Recruitment
